import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

function IntervalAuctionPlacements({ inventoryCampaign, label }) {
    if (!inventoryCampaign || (!inventoryCampaign?.related_categories?.length && !inventoryCampaign?.alt_versions?.length)) return null

    const { related_categories, alt_versions } = inventoryCampaign

    const categories = related_categories?.map(category => {
        let url = category.url
        if (!url) return null
        if (!url.includes('http')) {
            url = 'https://' + url
        }
        return {
            name: category.name,
            url
        }
    })

    const altVersions = alt_versions?.map(altVersion => {
        let url = altVersion.custom_url
        if (!url) return null
        if (!url.includes('http')) {
            url = 'https://' + url
        }
        return {
            name: altVersion.custom_name,
            url
        }
    })

    const data = [...categories, ...altVersions].filter(Boolean)

    if (!data.length) return null

    return data.map((item, index) => (
        <OverlayTrigger placement="bottom" overlay={<Tooltip placement="bottom">{item.name}</Tooltip>}>
            <a href={item.url} target="_blank" rel="noreferrer" className="btn btn-sm btn-outline-primary me-1 mb-1">
                {label} {index + 1}
                <i className="ri-external-link-line" style={{ marginLeft: '5px' }}></i>
            </a>
        </OverlayTrigger>
    ))
}

export default IntervalAuctionPlacements
